module.exports = __webpack_public_path__ + "img/republic-of-the-congo.73de8424.svg";